import React, { Component } from 'react';

class MessageTextArea extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const text = this.props.text
    const onTextChange = this.props.onTextChange
    return (
      <div>
      <form
        style={{ maxWidth: '400px', position: 'relative' }}
        onSubmit={{}}
        method="post"
        className="form__admin  form__admin--greyBg  u-padding-small"
      >

        <fieldset className="form__group  u-w-100  u-padding-bottom-small">
          <textarea className="form__group__inputFields  form__group__inputFields--textarea  u-border-box" value={text} onChange={onTextChange} cols="50" rows="10"></textarea>
        </fieldset>

      </form>
      </div>
    );
  }

}


export default MessageTextArea;



// WEBPACK FOOTER //
// ./src/cards/templates/RecommendAFriendCard/MessageTextArea.js